const IconSupport = () => (
  <svg
    width="31px"
    height="30px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.36 4.376a4.246 4.246 0 1 0 0 8.493 4.246 4.246 0 0 0 0-8.493ZM5.664 8.623a7.696 7.696 0 1 1 15.393 0 7.696 7.696 0 0 1-15.393 0ZM21.74 2.568a1.725 1.725 0 0 1 2.168-1.118l.379.121a7.675 7.675 0 0 1-.314 14.716l-.135.036a1.725 1.725 0 0 1-.91-3.328l.136-.037a4.225 4.225 0 0 0 .172-8.1l-.378-.122a1.725 1.725 0 0 1-1.118-2.168Zm5.631 17.687a1.725 1.725 0 0 1 2.056-1.313l.815.18a6.225 6.225 0 0 1 4.885 6.079v3.676a1.725 1.725 0 1 1-3.45 0v-3.676c0-1.303-.906-2.43-2.178-2.71l-.814-.18a1.725 1.725 0 0 1-1.314-2.056ZM7.798 22.352a4.275 4.275 0 0 0-4.275 4.274v2.251a1.725 1.725 0 1 1-3.45 0v-2.25A7.725 7.725 0 0 1 7.798 18.9h11.059a7.725 7.725 0 0 1 7.725 7.726v2.25a1.725 1.725 0 0 1-3.45 0v-2.25a4.275 4.275 0 0 0-4.275-4.275H7.798Z"
      fill="#fff"
    />
  </svg>
);

export default IconSupport;
